var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid',{staticClass:"pb-2",attrs:{"config":_vm.config,"disabled":_vm.disabled,"classes":_vm.classes,"labels":_vm.labels},on:{"select":_vm.onCellClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }